import { createContext, useContext, useState, useEffect } from "react";
import { EmotionColorStrategy } from "./EmotionColorStrategy"; 

const EmotionColorContext = createContext();

export const EmotionColorProvider = ({ children }) => {
  const [colorPorEmocion, setColorPorEmocion] = useState(() => {
    const saved = localStorage.getItem("coloresEmocion");
    return saved ? JSON.parse(saved) : {};
  });

  const strategy = new EmotionColorStrategy(colorPorEmocion);

  useEffect(() => {
    localStorage.setItem("coloresEmocion", JSON.stringify(colorPorEmocion));
  }, [colorPorEmocion]);

  const pintarEmocion = (emocion, colorKey) => {
    strategy.updateColor(emocion, colorKey);
    setColorPorEmocion({ ...strategy.colorPorEmocion });
  };

  const resetColores = () => {
    strategy.resetColors();
    setColorPorEmocion({}); 
  };

  return (
    <EmotionColorContext.Provider value={{ colorPorEmocion, pintarEmocion, resetColores }}>
      {children}
    </EmotionColorContext.Provider>
  );
};

export const useEmotionColor = () => useContext(EmotionColorContext);
